<template>
  <section class="flex justify-center items-center h-screen">
    <Card card_class="w-[450px] p-8">
      <AlertDanger v-if="alert_danger" @closeAlertDanger="hideAlertDanger()" :text="alert_text" />
      <h1 class="font-bold text-xl tracking-wider mb-8 text-center">{{ page_title }}</h1>
      <form @submit.prevent="login">
        <InputForm v-model="email" id="email" label="Email" type="email" input_class="mb-4 w-full" :is_required="true"/>
        <div class="mb-8">
          <label for="">Password</label>
          <div class="relative">
            <input v-model="password" id="password" :type="passwordInputType" class="w-full block text-lg mt-1 flex-1 rounded-3xl border-none border-b bg-transparent border-white/50 px-3 py-1 text-white placeholder:text-gray-300 placeholder:text-[12px] sm:text-sm sm:leading-6 focus:outline-none focus:ring-0 focus:shadow-lg focus:shadow-white/70 transition-shadow duration-500" required>
            <span class="absolute right-2 top-2">
              <EyeIcon @click="showPassword" :class="eyeIconClass + ' h-4 w-4 text-white cursor-pointer'"/>
              <EyeSlashIcon @click="hidePassword" :class="eyeSlashIconClass + ' h-4 w-4 text-white cursor-pointer'"/>
            </span>
          </div>
        </div>
        <div class="flex justify-center">
          <Button @click="login" button_text="Submit" button_type="submit"/>
        </div>
      </form>
    </Card>
  </section>
</template>

<script>
import axios from 'axios';
import Card from '@/components/organisms/Card.vue';
import InputForm from '@/components/form/InputForm.vue';
import Button from '@/components/buttons/Button.vue';
import AlertDanger from '@/components/alerts/AlertDanger.vue';
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/solid';

export default {
  data() {
    return {
      email: '',
      password: '',

      passwordInputType: 'password',
      eyeIconClass: '',
      eyeSlashIconClass: 'hidden',

      alert_danger: false,
      alert_text: 'lorem ipsum'
    }
  },
  components: {
    Card, InputForm, Button, AlertDanger,
    EyeIcon, EyeSlashIcon
  },
  computed: {
    page_title() {
      return this.$route.meta.page_title || "Untitled Page";
    },
  },
  methods: {
    showPassword() {
      this.passwordInputType = 'text';
      this.eyeIconClass = 'hidden';
      this.eyeSlashIconClass = '';
    },
    hidePassword() {
      this.passwordInputType = 'password';
      this.eyeIconClass = '';
      this.eyeSlashIconClass = 'hidden';
    },
    async login() {
      try {
        const response = await axios.post(`${process.env.VUE_APP_ROOT_API}/auth`, {
          email: this.email,
          password: this.password
        });

        if(response.data.status == 'success') {
          const token = response.data.data.token;

          localStorage.setItem('auth_token', token);
          this.$router.push('/home');
        }
        else {
          this.alert_danger = true;
          this.alert_text = response.data.message;
        }
      }
      catch(error) {
        this.alert_danger = true;
        this.alert_text = 'Email or Password is invalid';
        console.error('error: ', error);
      }
    },
    hideAlertDanger() {
      this.alert_danger = false;
      this.alert_text = '';
    },
  }
}
</script>

<style scope>
  section {
    height: calc(100% - 5rem);
  }
</style>